import React, { useState, useEffect } from "react";
import { Box } from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import { ProductsContextProvider } from "../../Context/ProductsContext";
import ProductForm from "./ProductForm";
import ContentCard from "../../Common/Layout/ContentCard";
import useFetch from "../../../hooks/useFetch";
import Body from "../../Common/Body";

const Product = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [product, setProduct] = useState({});
  const { id } = useParams();
  const { get } = useFetch();

  useEffect(() => {
    setIsLoading(true);
    if (id === "nuevo") {
      setProduct({
        name: "",
        cost: "",
        bulk: "",
        brand: null,
        category: null,
        subCategory: null,
        stock: "",
        minStock: "",
        image: "default.png",
        active: true,
      });
      setIsLoading(false);
    } else {
      get(`/products/${id}`)
        .then(async (res) => {
          setProduct(res);
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [useParams().id]);

  return (
    <ProductsContextProvider>
      <Body
        title={`Artículo ${
          product.name ? product.brand + " " + product.name : "Nuevo"
        }`}
        isLoading={isLoading}
      >
        <ContentCard>
          <Box
            fontSize="1.2em"
            fontWeight="bold"
            pb="5"
            textTransform="uppercase"
          >
            {product.name ? "Editar artículo" : "Artículo Nuevo"}
          </Box>
          <ProductForm product={product} id={id}></ProductForm>
        </ContentCard>
      </Body>
    </ProductsContextProvider>
  );
};

export default Product;
